import React from "react";
import { Navigate, Route, Routes } from "react-router-dom";
import { useSelector } from "react-redux";

import "./SettingsPage.scss";

import {
  MultipleProfileSettings,
  SingleProfileSettings,
} from "./ProfilesSettings";
import { Devices } from "../devices/DevicesOnSettings";
import { UrlFiltersSettingPage } from "../urlFilters/components/urlFiltersPage/UrlFiltersSettingPage";
import { isMultipleUserLevel, isSPSONAvailable } from "../../store/account";
import { SettingsProfileRouteGuard } from "./SettingsProfileRouteGuard";
import { getDefaultProfileId } from "../../store/profiles/profiles.selectors";
import { SpsonPage } from "../spson/SpsonPage";
import GlobalUrlFiltersPage from "../urlFilters/components/urlFiltersPage/GlobalUrlFiltersPage";

const MULTIPLE_ROUTES = {
  PROFILES: "profiles",
  URL_FILTERS: "url-filters",
  DEVICES: "devices",
};

const MultipleSettingsRouter = () => {
  const defaultProfileId = useSelector(getDefaultProfileId);

  return (
    <Routes>
      <Route
        path={MULTIPLE_ROUTES.PROFILES}
        element={<SettingsProfileRouteGuard />}
      >
        <Route path=":profileId" element={<MultipleProfileSettings />} />
      </Route>

      <Route
        path={MULTIPLE_ROUTES.DEVICES}
        element={<SettingsProfileRouteGuard />}
      >
        <Route path=":profileId/*" element={<Devices />} />
      </Route>

      <Route
        path={MULTIPLE_ROUTES.URL_FILTERS}
        element={<SettingsProfileRouteGuard isUrlFilters />}
      >
        <Route path=":profileId" element={<UrlFiltersSettingPage />} />
      </Route>

      <Route
        path="*"
        element={
          <Navigate to={`${MULTIPLE_ROUTES.PROFILES}/${defaultProfileId}`} />
        }
      />
    </Routes>
  );
};

const SINGLE_ROUTES = {
  PROFILES: "profiles",
  SPS_REMOTE: "sps-remote",
  GLOBAL_URL_FILTERS: "global-url-filters",
};

const SingleSettingsRouter = () => {
  const SPSONAvailable = useSelector(isSPSONAvailable);

  return (
    <Routes>
      <Route
        path={SINGLE_ROUTES.PROFILES}
        element={<SingleProfileSettings />}
      />

      {SPSONAvailable && (
        <Route path={SINGLE_ROUTES.SPS_REMOTE} element={<SpsonPage />} />
      )}

      <Route
        path={SINGLE_ROUTES.GLOBAL_URL_FILTERS}
        element={<GlobalUrlFiltersPage />}
      />

      <Route path="*" element={<Navigate to={SINGLE_ROUTES.PROFILES} />} />
    </Routes>
  );
};

export const SettingsPage = () => {
  const isMultiple = useSelector(isMultipleUserLevel);

  return isMultiple ? <MultipleSettingsRouter /> : <SingleSettingsRouter />;
};
